module.exports = __webpack_public_path__ + "img/ZW.20337188.svg";